import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ allowRoles }: { allowRoles?: string[] }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="p-8 text-slate-500">Загрузка…</div>;
  }
  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }
  if (allowRoles && !allowRoles.includes(user.role)) {
    return <Navigate to="/403" replace />;
  }
  return <Outlet />;
}